export default "__VITE_ASSET__CVHtPVVa__ 778w";